module.exports = __webpack_public_path__ + "static/img/rank_86.23de18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_86.png
// module id = qLXk
// module chunks = 1